import { render, staticRenderFns } from "./custom-date-picker.vue?vue&type=template&id=36d941dc&scoped=true"
import script from "./custom-date-picker.vue?vue&type=script&lang=js"
export * from "./custom-date-picker.vue?vue&type=script&lang=js"
import style0 from "./custom-date-picker.vue?vue&type=style&index=0&id=36d941dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d941dc",
  null
  
)

export default component.exports